import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import {
    ATTACHMENT_LEVEL,
    ATTACHMENT_STATUS,
} from "constants/generalConstants";
import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    clearScanAttachmentResult,
    setAvailableAttachmentsToCopyAction,
    setLevelType,
    setShowAttachmentCopyDialog,
} from "redux/actions/attachmentActions";
import { setShowRequisitionDialogue } from "redux/actions/generalActions";
import { copyAttachmentFiles } from "services/attachment/attachmentAPIs";
import { baseStyledPaperSX } from "styled/styledSXProperties/styledPaperSX";

import UploadedFiles from "../attachmentUpload/UploadedFiles";
import AttachmentListDialog from "./attachmentListDialog";

export default function CopyAttachmentFilesDialog() {
    const [modalDisableCopy, setModalDisableCopyButton] = useState(false);
    const dispatch = useDispatch();

    const showAttDialog = useSelector(
        (state) => state.attachment.showAttachmentCopyDialog
    );

    const availableAttachmentsToCopy = useSelector(
        (state) => state.attachment.availableAttachmentsToCopy
    );

    const scanResults = useSelector((state) => state.attachment.scanResults);

    const darkMode = useSelector((state) => state.general.darkMode);

    const disableCopy = useSelector((state) => state.attachment.disableCopy);

    const levelType = useSelector((state) => state.attachment.levelType);

    const handleCopy = async () => {
        try {
            setModalDisableCopyButton(true);

            // Need to filter selected file and which is not already copied (File will be in scanResults if it is already copied)
            const attachmentListToCopy = availableAttachmentsToCopy.filter(
                (a) =>
                    a.isSelectedToCopy &&
                    !a.isCopied &&
                    !scanResults.some(
                        (item) =>
                            (item.OLD_ATTACHMENT_ID ?? item.ATTACHMENT_ID) ===
                            a.ATTACHMENT_ID
                    )
            );
            await copyAttachmentFiles(attachmentListToCopy, dispatch);
            setModalDisableCopyButton(false);
        } catch (error) {
            setModalDisableCopyButton(false);
            console.log(error);
        }
    };

    const isCopyButtonDisabled = () => {
        if (modalDisableCopy || disableCopy) {
            return true;
        }

        return false;
    };

    const handleProceedSubmit = () => {
        dispatch(setShowAttachmentCopyDialog(false));
        dispatch(setShowRequisitionDialogue(true));

        // If no level type is selected, this helps to set the default header level and it will be shown in File upload dialog in requisition line edit options
        if (!levelType) {
            dispatch(setLevelType(ATTACHMENT_LEVEL.HEADER));
        }
        dispatch(setAvailableAttachmentsToCopyAction([]));
    };

    const handleCancel = () => {
        dispatch(setShowAttachmentCopyDialog(false));
        dispatch(clearScanAttachmentResult());
        dispatch(setAvailableAttachmentsToCopyAction([]));
    };

    return (
        <Dialog
            open={showAttDialog}
            // onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: baseStyledPaperSX(darkMode) }}
        >
            <DialogTitle>
                <Stack>
                    <Typography
                        variant="h3"
                        marginBottom={"4px"}
                        align={"center"}
                    >
                        Select Attachments to Copy
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <AttachmentListDialog />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    style={{ marginRight: "18px" }}
                    onClick={handleCopy}
                    type="submit"
                    disabled={isCopyButtonDisabled()}
                >
                    Copy
                </Button>
            </DialogActions>
            <DialogContent>
                <UploadedFiles titleText="Copy Attachments" mode="Copy" />
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={handleCancel}>
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleProceedSubmit}
                    type="submit"
                    disabled={
                        scanResults?.length > 0 &&
                        scanResults?.every((obj) => {
                            return (
                                obj?.status &&
                                obj?.status === ATTACHMENT_STATUS.SCAN_COMPLETED
                            );
                        })
                            ? false
                            : true
                    }
                >
                    Proceed
                </Button>
            </DialogActions>
        </Dialog>
    );
}
